import React from 'react';
import Chip from '@material-ui/core/Chip';
import { businessSegments } from '../segments/data';

const styles = {
  main: { display: 'flex', flexWrap: 'wrap' },
  chip: { margin: 4 }
};

const SegmentsField = ({ record, translate }) => (
  <span style={styles.main}>
    <Chip
      key={record.business_type}
      style={styles.chip}
      label={
        record.business_type
          ? businessSegments.find(s => s.id === record.business_type).name
          : 'NA'
      }
    />
  </span>
);

SegmentsField.defaultProps = {
  addLabel: true,
  source: 'business_type'
};

export default SegmentsField;



// WEBPACK FOOTER //
// ./src/business/SegmentsField.js